import { render, staticRenderFns } from "./BaseAlertList.vue?vue&type=template&id=0111497b&scoped=true&"
import script from "./BaseAlertList.vue?vue&type=script&lang=ts&"
export * from "./BaseAlertList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0111497b",
  null
  
)

export default component.exports